<template>
  <component
    v-if="componentName"
    :is="componentName"
    :width="width"
    :height="height"
    class="inline-block shrink-0"
  />
</template>

<script>
import { navIconComponentName } from '@/utils/navIcons'

export default {
  props: {
    name: {
      type: String,
      default: null,
    },
    width: {
      type: [Number, String],
      default: 16,
    },
    height: {
      type: [Number, String],
      default: 16,
    },
  },

  computed: {
    /**
     * Resolved global icon component name
     */
    componentName() {
      return navIconComponentName(this.name)
    },
  },
}
</script>
